import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQItem from '../components/FAQItem';
import { FiFlag, FiHeart, FiLink, FiMessageCircle, FiSearch, FiShare2, FiUser, FiUsers } from 'react-icons/fi';

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-[#F4FBF8] text-[#17231F]">
      <Header />

      <section className="relative overflow-hidden bg-[#E9F6F0]">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1554224154-26032ffc0d07?auto=format&fit=crop&q=80&w=1800"
            alt="Finance support workspace"
            className="h-full w-full object-cover opacity-15"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#E9F6F0] via-[#E9F6F0]/90 to-[#E9F6F0]/75" />
        </div>
        <div className="absolute inset-x-0 bottom-0 h-[3px] bg-gradient-to-r from-[#D97706] via-[#14B8A6] to-[#166534]" />
        <div className="relative mx-auto grid max-w-7xl gap-8 px-4 py-16 sm:px-6 lg:grid-cols-[0.35fr_0.65fr] lg:px-8 lg:py-24">
          <div>
            <div className="inline-flex w-fit items-center gap-2 rounded-full border border-emerald-900/10 bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-[#0F766E] shadow-lg shadow-emerald-950/5">
              FAQS
            </div>
          </div>
          <div>
            <div className="mb-6 h-1.5 w-20 rounded-full bg-[#D97706]" />
            <h1 className="max-w-3xl text-4xl font-semibold leading-tight tracking-tight text-[#0B2F2A] sm:text-5xl">
              Frequently asked questions
            </h1>
          </div>
        </div>
      </section>

      <main className="bg-[#F4FBF8] px-4 py-20 text-[#17231F] sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.28fr_0.72fr]">
          <aside className="hidden lg:block">
            <div className="sticky top-28 border-l-4 border-[#D97706] pl-5">
              <p className="text-sm font-semibold text-[#0B2F2A]">Support topics</p>
              <p className="mt-3 text-sm leading-7 text-[#56736B]">
                Answers about subscription management, billing questions, customer account access, and cancellation requests.
              </p>
            </div>
          </aside>
          <div>
            <FAQItem title="Why do I have a personalfinancecare.com charge on my bank statement?" icon={<FiHeart />}>
              If a direct debit appears on your statement, you have probably signed up to a subscription to one of our partner sites for which we provide the after-sales service. Please note that you are not a client of personalfinancecare.com, but a client of a site that has delegated the management of its customer service.
            </FAQItem>

            <FAQItem title="What are the services offered by personalfinancecare.com?" icon={<FiFlag />}>
              personalfinancecare.com offers simplified management of your subscription. Fill in the form on the home page with an e-mail address used at the time of subscription. You will be able to contact the agents responsible for your file, obtain all the information concerning your subscription or cancel it.
            </FAQItem>

            <FAQItem title="What kind of subscription do you need for after-sales service?" icon={<FiSearch />}>
              personalfinancecare.com provides customer service subscriptions that make your life easier. We work with sites that offer help to individuals or professionals, accompanying the client during various operations or steps.
            </FAQItem>

            <FAQItem title="I do not remember signing up to a personalfinancecare.com subscription." icon={<FiShare2 />}>
              You have not signed up to a personalfinancecare.com subscription. You have definitely signed up to a subscription at one of our partner sites for which we provide after-sales service.
            </FAQItem>

            <FAQItem title="How to find the offer to which I subscribed?" icon={<FiLink />}>
              Fill in the form on the home page with the email address used when registering. We will provide you with important information about your subscription, such as the date and amount of the next withdrawal and the service features you have selected.
            </FAQItem>

            <FAQItem title="I forgot the email address used when subscribing. What can I do?" icon={<FiUser />}>
              If you are unable to retrieve the email address used during the subscription, our agents always have the possibility to find your client file. Contact our agents by email or chat.
            </FAQItem>

            <FAQItem title="Who can I contact if I have a question?" icon={<FiMessageCircle />}>
              Our agents are experts in after-sales service and are available 24/7. Contact them by live chat or by phone via our toll-free number any time you need. You can also send them a message.
            </FAQItem>

            <FAQItem title="How can I cancel my subscription?" icon={<FiUsers />}>
              Go to your customer account and click the Cancel button. You will no longer benefit from the services of our partner site and will no longer be charged. A confirmation email will be sent.
            </FAQItem>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
